var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 1.83317C18.7754 1.83317 19.1993 2.00877 19.5118 2.32133C19.8244 2.63389 20 3.05781 20 3.49984V11.8332C20 12.2752 19.8244 12.6991 19.5118 13.0117C19.1993 13.3242 18.7754 13.4998 18.3333 13.4998H5C4.55797 13.4998 4.13405 13.3242 3.82149 13.0117C3.50893 12.6991 3.33333 12.2752 3.33333 11.8332V1.83317C3.33333 1.39114 3.50893 0.96722 3.82149 0.654659C4.13405 0.342099 4.55797 0.166504 5 0.166504H10L11.6667 1.83317H18.3333ZM1.66667 3.49984V15.1665H16.6667V16.8332H1.66667C1.22464 16.8332 0.800716 16.6576 0.488155 16.345C0.175595 16.0325 0 15.6085 0 15.1665V7.6665V3.49984H1.66667ZM5 3.49984V11.8332H18.3333V3.49984H5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGroup);
export default __webpack_public_path__ + "static/media/new-group.d1284dab.svg";
export { ForwardRef as ReactComponent };